import { useMemo } from 'react';
import { GroupIds, scopeKey, scopeToGroupIds, WhereaboutsScope } from '@features/whereabouts/models/whereaboutsScope';
import { useFollowedGroupIds } from './useFollowedGroupIds';

// The team/workgroup ids a whereabouts view should load for the given scope:
// the followed ids for the default scope, or the single pinned id otherwise.
// Referentially stable while unchanged, so safe to use as effect deps.
export function useScopedGroupIds(scope: WhereaboutsScope): GroupIds {
  const followed = useFollowedGroupIds();
  const key = scopeKey(scope);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => scopeToGroupIds(scope, followed), [key, followed.teamIds, followed.workGroupIds]);
}
